// extracted by mini-css-extract-plugin
module.exports = {"item":"item_item__1xotL","titl":"item_titl__1pTs-","sub-title":"item_sub-title__1FXCG"};